import { Component } from '@verndale/core';
import Swiper from 'swiper';

class GifSectionsWithMenu extends Component {
  setupDefaults() {
    this.dom = {
      tabs: this.el.querySelectorAll('.gif-sections__tab'),
      tabPanels: this.el.querySelectorAll('.gif-sections__tab-panel'),
      swiper: this.el.querySelector('.gif-sections__swiper-container')
    };
    this.tablet = window.matchMedia('(min-width: 768px)');
    this.showActivePanel(this.dom.tabs[0].getAttribute('aria-controls'));
    this.setupSwiper();
  }

  addListeners() {
    this.dom.tabs.forEach(tab => {
      tab.addEventListener('mouseover', this.handleTabClick.bind(this));
      tab.addEventListener('focus', this.handleTabClick.bind(this));
    });

    this.tablet.onchange = e => {
      if (!e.matches) {
        this.setupSwiper();
      }
    };
  }

  hideAllPanels() {
    this.dom.tabPanels.forEach(panel => {
      panel.hidden = true;
    });
    this.dom.tabs.forEach(tab => {
      tab.classList.remove('gif-sections__tab--active');
    });
  }

  showActivePanel(tabId) {
    this.dom.tabPanels.forEach(panel => {
      if (panel.id === tabId) panel.hidden = false;
    });
    this.dom.tabs.forEach(tab => {
      if (tab.getAttribute('aria-controls') === tabId)
        tab.classList.add('gif-sections__tab--active');
    });
  }

  handleTabClick(e) {
    const tab = e.currentTarget;
    const tabId = tab.getAttribute('aria-controls');
    this.hideAllPanels();
    this.showActivePanel(tabId);
  }

  setSameHeight() {
    const tabPanels = this.el.querySelectorAll(
      '.gif-sections__tab-panel-media-container'
    );
    const tabPanelsArray = Array.from(tabPanels);
    tabPanelsArray.forEach(tabPanel => {
      tabPanel.removeAttribute('style');
    });
    const tabPanelsHeight = tabPanelsArray.map(
      tabPanel => tabPanel.offsetHeight
    );
    const maxHeight = Math.max(...tabPanelsHeight);
    tabPanelsArray.forEach(tabPanel => {
      tabPanel.removeAttribute('style');
      tabPanel.style.height = `${maxHeight}px`;
    });
  }

  setupSwiper() {
    if (this.tablet.matches) return;
    this.swiper = new Swiper('.gif-sections__swiper', {
      slidesPerView: 1.1,
      spaceBetween: 16,
      freeMode: true,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      setWrapperSize: true,
      height: 300,
      on: {
        init: () => {
          if (this.dom.tabs.length) {
            this.dom.tabs.forEach((tab, index) => {
              tab.addEventListener('mouseover', () => {
                if (!this.swiper.destroy || this.swiper.enabled)
                  this.swiper.slideTo(index);
              });
            });
          }
        },
        afterInit: () => {
          this.setSameHeight();
        },
        slideChange: () => {
          this.hideAllPanels();
          this.showActivePanel(this.swiper.slides[this.swiper.activeIndex].id);
        },
        resize: () => {
          if (this.tablet.matches) {
            this.swiper.destroy(true, true);
          } else {
            this.setSameHeight();
          }
        }
      }
    });
  }
}

export default GifSectionsWithMenu;
